<template>
  <div class="container">
    <div class="vue">
      <el-row class="nav">
        <el-col class="col flex" :span="14" :offset="5">
          <div class="header width100 flex flexJc-sb flexAi-c">
            <div class="head-left">
              <el-image
                style="width: 120px; height: 42px"
                :src="require('@/assets/image/public/logo.png')"
              ></el-image>
            </div>
            <div class="head-right">
              <el-menu
                class="el-menu-demo flex"
                mode="horizontal"
                text-color="#319f8f"
                background-color="#fff"
                active-text-color="#319f8f"
                router
                :default-active="$route.path"
              >
                <el-menu-item
                  v-for="(item, index) in items"
                  :key="index"
                  :index="item.url"
                  @click="cccc(item)"
                >
                  <span slot="title">{{ item.name }}</span>
                </el-menu-item>
              </el-menu>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="data">
        <div class="banner ">
          <el-image
            class="block"
            :src="require('@/assets/image/webImage/banner.jpg')"
          ></el-image>
        </div>
        <div class="data-content">
          <!-- 路由 -->
          <router-view></router-view>
        </div>
      </div>
      <div class="footer">
        <el-row>
          <el-col class="col flex " :span="14" :offset="5">
            <div class="footer-left flex   whiteC6Col">
              <div class="question">
                <div class="title FontW6  whiteCol">常见问题</div>
                <div class="hover cursorPo" @click="login">后台登录</div>
                <div class="hover cursorPo" @click="download">下载方式</div>
                <div class="hover cursorPo" @click="complaint">版权投诉</div>
              </div>
              <!-- <div class="question">
                <div class="title FontW6 whiteCol ">关于我们</div>
                <div class="hover cursorPo">我们的服务</div>
                <div class="hover cursorPo">公司简介</div>
                <div class="hover cursorPo">服务资讯</div>
                <div class="hover cursorPo">客户端</div>
              </div> -->
              <div class="question address">
                <div class="whiteCol title FontW6 ">服务地址</div>
                <div>滨湖区稻香新村60号北桥社区居家服务中心</div>
                <div>滨湖区荣巷街道龙山路8号</div>
                <div>梁溪区蓉湖新村廉政文化站</div>
                <div>梁溪区盛岸二村西区</div>
                <div>锡山区华夏豪门小区内</div>
              </div>
            </div>
            <div class="footer-right flex flexAi-fe  flexJc-c">
              <el-image
                :src="require('@/assets/image/public/gzh.jpg')"
              ></el-image>
              <span class="whiteCol name">官方公众号</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="other_link textA-C padVertical10 whiteC6Col">
        <span>Copyright © 2024 LYTJJFWYFGS.All rights reserved. </span>
          <a href="https://beian.miit.gov.cn/" target="_blank" style="color: white;">苏ICP备2024147615号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
// 导入我们的api接口
import { apiFindLevelOne } from '@/api/share'
export default {
  name: '',
  props: [''],
  data() {
    return {
      image: {},
      items: [
        { name: '首页', url: '/Home' },
        { name: '服务资讯', url: '/message' },
        { name: '客户端', url: '/client' },
        { name: '关于我们', url: '/AboutUs' }
      ]
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.FindLevelOne()
  },

  methods: {
    cccc(row) {
      console.log(row)
    },
    loginBut() {
      this.$router.push({
        path: '/login'
      })
    },
    login() {
      this.$router.push({
        path: '/login'
      })
    },
    download() {
      this.$router.push({
        path: '/client'
      })
    },
    // 版权投诉
    complaint() {
      this.$alert('可拨打 0510-85102020 进行咨询投诉', '版权投诉', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    },
    /* 接口 */
    // 查找一级目录的导航栏
    FindLevelOne() {
      apiFindLevelOne().then(res => {
        if (res.status === '0') {
          // this.activeIndex = res.data[0].id.toString()
          this.items = res.data
          console.log(this.parentOptions)
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
body {
  font-size: calc(12px + (16 - 12) * ((100vw - 400px) / (1500 - 400)));
}
.el-menu-item.is-active {
  font-weight: 700;
}
.container {
  background-color: #fff;
  .vue {
    .header {
      .head-right {
        .el-menu-demo {
          border-bottom: 0;
        }
      }
    }
    .data-content {
    }
    .footer {
      padding: 40px 0;
      background: #1d1d1d;
      .footer-left {
        width: 60%;
        .question {
          .title {
            padding: 10px 0;
            font-size: 18px;
          }
          div {
            padding: 3px 0;
          }
          .hover:hover {
            color: #319f8f;
          }
        }
        .address {
          padding-left: 50px;
        }
      }
      .footer-right {
        flex-direction: column;
        width: 40%;
        /deep/ img {
          width: 100px;
          height: 100px;
        }
        .name {
          padding: 6px 0;
          padding-right: 15px;
        }
      }
    }
    .other_link {
      background: #272727;
    }
  }
}
</style>
